import { InjectionToken, Type } from "@angular/core";
import type { CerrixPromptComponent } from "./cerrix-prompt.component";

/**
 * The component class CerrixPromptService opens as a Material dialog.
 *
 * generic-field-editor's custom field types transitively depend on CerrixPromptService (through
 * cerrix-select-tree), and cerrix-prompt.component.ts itself imports generic-field-editor to
 * render its fields inside the prompt dialog. A direct import of CerrixPromptComponent in the
 * service would close that cycle, so it resolves the class through this token instead.
 * SharedModule.forRoot() provides the token.
 */
export const CERRIX_PROMPT_COMPONENT = new InjectionToken<Type<CerrixPromptComponent>>(
    "CERRIX_PROMPT_COMPONENT",
);
